import styled from 'styled-components';
import { IconWithText } from '../../../stories/molecules';
import { muiTheme } from '../../../theme';
import { ThemeMode } from '../../../global-state/themeContext';

// TODO: Remove this when the expired action is implemented [BTCOBUI-3288]
const getColor = (isDisabled: boolean, palette: ThemeMode) => {
  if (isDisabled) {
    return palette === 'dark' ? muiTheme.color.borderGrayDark : muiTheme.color.textGray;
  }
  return palette === 'dark' ? muiTheme.color.white : muiTheme.color.primary;
};
// TODO: Remove this when the expired action is implemented [BTCOBUI-3288]
export const StyledIconWithText = styled(IconWithText)<{ isDisabled: boolean }>`
  & > div {
    color: ${({ theme: { palette }, isDisabled }) => getColor(isDisabled, palette.mode)};
    cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
  }
`;
